// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/version/size/footprint.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.footprint',
	post: false,
	require: function(config, filter) { return sorted('version.size.footprint', filter) > 0 },
	run: function(config, filter, data, query) {
		var expr = '(v.game_version_storage_width * v.game_version_storage_length * v.game_version_storage_depth)'
		query.order(expr, sortReverse('version.size.footprint', filter), sortPriority('version.size.footprint', filter))
	}
}
